/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SegmentsGetSegmentThumbnailQueryResponse, SegmentsGetSegmentThumbnailPathParams, SegmentsGetSegmentThumbnail400, SegmentsGetSegmentThumbnail401, SegmentsGetSegmentThumbnail403, SegmentsGetSegmentThumbnail404 } from "../models/SegmentsGetSegmentThumbnail";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { segmentsGetSegmentThumbnail } from "../axios/segmentsGetSegmentThumbnail";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const segmentsGetSegmentThumbnailQueryKey = (station: SegmentsGetSegmentThumbnailPathParams["station"], segment: SegmentsGetSegmentThumbnailPathParams["segment"]) => ["api-v2", { url: '/segments/v1/stations/:station/segments/:segment/thumbnail', params: {station:station,segment:segment} }] as const

export type SegmentsGetSegmentThumbnailQueryKey = ReturnType<typeof segmentsGetSegmentThumbnailQueryKey>

export function segmentsGetSegmentThumbnailQueryOptions(station: SegmentsGetSegmentThumbnailPathParams["station"], segment: SegmentsGetSegmentThumbnailPathParams["segment"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = segmentsGetSegmentThumbnailQueryKey(station, segment)
        return queryOptions<SegmentsGetSegmentThumbnailQueryResponse, ResponseErrorConfig<SegmentsGetSegmentThumbnail400 | SegmentsGetSegmentThumbnail401 | SegmentsGetSegmentThumbnail403 | SegmentsGetSegmentThumbnail404>, SegmentsGetSegmentThumbnailQueryResponse, typeof queryKey>({
         enabled: !!(station&& segment),
         queryKey,
         queryFn: async ({ signal }) => {
            return segmentsGetSegmentThumbnail(station, segment, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns the thumbnail URL and metadata for a video segment identified by its start timestamp.
 * @summary Get thumbnail for a single segment
 * {@link /segments/v1/stations/:station/segments/:segment/thumbnail}
 */
export function useSegmentsGetSegmentThumbnail<TData = SegmentsGetSegmentThumbnailQueryResponse, TQueryData = SegmentsGetSegmentThumbnailQueryResponse, TQueryKey extends QueryKey = SegmentsGetSegmentThumbnailQueryKey>(station: SegmentsGetSegmentThumbnailPathParams["station"], segment: SegmentsGetSegmentThumbnailPathParams["segment"], options: 
{
  query?: Partial<QueryObserverOptions<SegmentsGetSegmentThumbnailQueryResponse, ResponseErrorConfig<SegmentsGetSegmentThumbnail400 | SegmentsGetSegmentThumbnail401 | SegmentsGetSegmentThumbnail403 | SegmentsGetSegmentThumbnail404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? segmentsGetSegmentThumbnailQueryKey(station, segment)
         

         const query = useQuery({
          ...segmentsGetSegmentThumbnailQueryOptions(station, segment, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SegmentsGetSegmentThumbnail400 | SegmentsGetSegmentThumbnail401 | SegmentsGetSegmentThumbnail403 | SegmentsGetSegmentThumbnail404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}